import { Filter } from 'bad-words'

/**
 * Convert a string to an array of char codes
 */
export const _decomposeString = (str = '') => {
  return [...str].map((char) => char.charCodeAt(0))
}

/**
 * Compose a string from array of char codes
 */
export const _composeString = (arr: number[]) => {
  return String.fromCharCode(...arr)
}

const RESERVED = [
  'admin',
  'moderator',
] as const
const RESERVED_EMOJI = ['✓', '☑', '✅', '☑️', '✔️', '🗸', '🗹']
const filter = new Filter()

/**
 * Check for reserved words and English bad word
 * @return true if no bad word found
 */
export const _verifyStringLocal = (name: string) => {
  // 1. Check for the existent of PaperMaker string (case insensitive)
  const coreName = name.toLowerCase().replace(/([^\w])|_/g, '')
  const hasPmkString = coreName.match(/paper.*maker/g)

  if (hasPmkString) {
    return false
  }

  // 2. Check for reserved words
  const reserved = RESERVED.map((word) => coreName.includes(word)).reduce((r, ri) => r || ri, false)

  if (reserved) {
    return false
  }

  // 3. Check for English bad words with 3rd party library
  if (filter.isProfane(name) || filter.isProfane(coreName)) {
    return false
  }

  // 4. Check for reserved emoji
  let re = false
  for (let i = 0; i < RESERVED_EMOJI.length; i++) {
    if (name.includes(RESERVED_EMOJI[i])) {
      re = true
      break
    }
  }
  if (re) {
    return false
  }

  return true
}

export const _cleanBadWords = (str: string) => {
  try {
    // filter.clean will throw exception for empty string
    return filter.clean(str)
  } catch {
    return str
  }
}

const EMOJI_REGEX = /[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2580-\u27BF]|\uD83E[\uDD10-\uDDFF]/g

export const _cleanEmoji = (str: string) => {
  return str.replace(EMOJI_REGEX, '').trim()
}

export const _verifyEmoji = (str: string) => {
  return str.trim().length === _cleanEmoji(str).length
}

// file name/path related util
export const _extractFileName = (path: string) => {
  const slashIndex = path.lastIndexOf('/')
  if (slashIndex >= 0) {
    return path.substring(slashIndex + 1)
  } else {
    return path
  }
}
